import React from 'react';
import MyNavbar from './components/Navbar';
import MyFooter from './components/Footer';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Container } from 'react-bootstrap';

import Home from './pages';
import Career from './pages/career';
import Leistungen from './pages/leistungen';
import About from './pages/about';
import Kontakt from './pages/kontakt';
import Partner from './pages/partner';
import CookieConsent from "react-cookie-consent";
import Datenschutz from './pages/datenschutz';
import Impressum from './pages/impressum';

import './App.scss';

function App() {
  return (
    <BrowserRouter>
    <CookieConsent
      location="bottom"
      enableDeclineButton
      buttonText="Akzeptieren"
      declineButtonText="Ablehnen"
      cookieName="heinrich-heiden.de"
      style={{ background: "#FFFFFF", color: "#303C49"}}
      buttonStyle={{ color: "#FFFFFF", backgroundColor: "#E40045", fontSize: "13px" }}
      expires={150}
    >
      Diese Internetseite nutzt Cookies und GoogleMaps um Ihr Erlebnis zu verbessern. Mit dem Klick auf 'Akzeptieren' stimmen Sie der Datenschutzerklärung von Google zu.{" "}
    </CookieConsent>
      <MyNavbar />
      <Container fluid="lg">
        <Routes>
          <Route path='/' exact element={<Home />} />
          <Route path='/leistungen' element={<Leistungen />} />
          <Route path='/career' element={<Career />} />
          <Route path='/about' element={<About />} />
          <Route path='/kontakt' element={<Kontakt />} />
          <Route path='/partner' element={<Partner />} />

          <Route path='/datenschutz' element={<Datenschutz />} />
          <Route path='/impressum' element={<Impressum />} />
        </Routes>
      </Container>
      <MyFooter className="footer-wrapper" />
    </BrowserRouter>
  );
}

export default App;
